module.exports = __webpack_public_path__ + "static/img/MADRID_PAINT.290280a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/MADRID_PAINT.jpg
// module id = Xwau
// module chunks = 0